function removeCartBundle(event) {
  let bundle_items = document.querySelectorAll("[data-bundle-item]");
  let myData = {};
  
  bundle_items.forEach((item) => {
    let item_id = item.getAttribute("data-bundle-item-id");
    myData[item_id] = 0;
  });

  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates: myData })
  })
  .then(response => response.json())
  .then(() => {
    window.location.reload();
  })
  .catch(error => {
    alert(`Error: ${error.description || "Something went wrong"}. Try Again...`);
    console.error("Cart Update Error:", error);
  });
}

  function accordionToggle(event) {
    const button = document.querySelector('.card-bundle__product-toggle');
    button.classList.toggle("active");
    let main_wrapper = document.querySelector('.cart-bundle-wrapper');
    main_wrapper.classList.toggle("active");
  }